import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')

const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudDeposits = () => import('./staff/crudDeposits')
const ViewStaffCrudDepositsOperations = () => import('./staff/crudOperations')
const ViewStaffCrudDepositsQuery = () => import('./staff/crudQuery')
const ViewStaffCrudDepositsQueryLocations = () => import('./staff/crudQueryLocations')
const ViewStaffCrudDepositsStockCount = () => import('./staff/stockCount')

Vue.use(Router)

const router =
  [
    {
      path: '/st/deposits',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'DepositsStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Depósitos',
          }          
        },        
        {
          path: 'deposits',
          name: 'DepositsStaffCrudDeposits',
          component: ViewStaffCrudDeposits,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Depósitos',
          }          
        },
        {
          path: 'deposits-query',
          name: 'DepositsStaffCrudDepositsQuery',
          component: ViewStaffCrudDepositsQuery,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Stock por Producto',
          }          
        },             
        {
          path: 'deposits-operations',
          name: 'DepositsStaffCrudDepositsOperations',
          component: ViewStaffCrudDepositsOperations,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Operaciones de Depósitos',
          }          
        },    
        {
          path: 'deposits-query-locations',
          name: 'DepositsStaffCrudDepositsQueryLocations',
          component: ViewStaffCrudDepositsQueryLocations,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Stock por Ubicación',
          }
        },
        {
          path: 'stock-count',
          name: 'DepositsStaffCrudDepositsStockCount',
          component: ViewStaffCrudDepositsStockCount,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Recuento de Stock',
          }
        },
      ]
    },

    {
      path: '/cu/deposits',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/deposits',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
